<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import QuestionAnswer from '/src/components/QuestionAnswer.vue'
import QuestionPage from '/src/components/QuestionPage.vue';
import { MDBBtn} from "mdb-vue-ui-kit";
import { mapFields } from 'vuex-map-fields';

export default {
  components: {
    QuestionAnswer,
    QuestionPage,
    MDBBtn,
  },
  computed: {
    ...mapFields([
      'scene.status.house'
    ]),
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('house')
    }
  },
  methods: {
    ...mapMutations([
      'selectHouseStatus',
      'goToNextPage',
      'moveToItem'
    ]),
    ...mapActions([
      'goToItem'
    ]),
    chooseBasic: function () {
      this.selectHouseStatus(1);
      this.house = 1
    },
    chooseMedium: function () {
      this.selectHouseStatus(2);
      this.house = 2
    },
    chooseTop: function () {
      this.selectHouseStatus(3);
      this.house = 3
    }
  },
};
</script>

<template>
  <QuestionPage :title="questionAnswerData.question">
    <Transition name="switch" mode="out-in" appear>
      <div v-if="house < 2"
        class="question_image question_image_home_minimum d-block d-sm-none"
      ></div>
      <div v-else-if="house == 2"
        class="question_image question_image_home_medium d-block d-sm-none"
      ></div>
      <div v-else-if="house == 3"
        class="question_image question_image_home_top d-block d-sm-none"
      ></div>
    </Transition>

    <!-- show on desktop only -->
    <QuestionAnswer
      :title='questionAnswerData.answers.A'
      class='d-none d-sm-block'
      :onSelect="chooseBasic"
      @click="goToItem('house')"
      :imageName="questionAnswerData.images.Q2AA"
    />
    <QuestionAnswer
      :title='questionAnswerData.answers.B'
      class='d-none d-sm-block'
      :onSelect="chooseMedium"
      @click="goToItem('house')"
      :imageName="questionAnswerData.images.Q2AB"
    />
    <QuestionAnswer
      :title='questionAnswerData.answers.C'
      class='d-none d-sm-block'
      :onSelect="chooseTop"
      @click="goToItem('house')"
      :imageName="questionAnswerData.images.Q2AC"
    />

    <!-- on mobile only -->
    <div class='d-flex d-sm-none questions-on-mobile'>
      <QuestionAnswer
        :title='questionAnswerData.answers.A'
        class='answer-home-basic question_answer--extra-spacing'
        :onSelect="chooseBasic"
      />
      <QuestionAnswer
        :title='questionAnswerData.answers.B'
        class='answer-home-medium question_answer--extra-spacing'
        :onSelect="chooseMedium"
      />
      <QuestionAnswer
        :title='questionAnswerData.answers.C'
        class='answer-home-top question_answer--extra-spacing'
        :onSelect="chooseTop"
      />
      <MDBBtn class="next-btn-on-mobile" @click="moveToItem('house')">next</MDBBtn>
    </div>

  </QuestionPage>
</template>
